export class SparkConnectCredentials {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "token",
            "baseName": "token",
            "type": "string",
            "format": ""
        },
        {
            "name": "connectUrl",
            "baseName": "connectUrl",
            "type": "string",
            "format": ""
        },
        {
            "name": "host",
            "baseName": "host",
            "type": "string",
            "format": ""
        },
        {
            "name": "port",
            "baseName": "port",
            "type": "number",
            "format": ""
        },
        {
            "name": "useSsl",
            "baseName": "useSsl",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "caCertPem",
            "baseName": "caCertPem",
            "type": "string",
            "format": ""
        },
        {
            "name": "airflowConnection",
            "baseName": "airflowConnection",
            "type": "SparkConnectCredentialsAirflowConnection",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SparkConnectCredentials.attributeTypeMap;
    }
    constructor() {
    }
}
